import { UPDATE_MANAGER } from './redux.actionTypes';

export const updateManager = ({ handleSubmit, ...payload }) => {
    console.log(payload, '===========================');
    return {
        type: UPDATE_MANAGER,
        meta: { handleSubmit },
        payload
    };
};
